<template>
<v-container>
  <v-form v-if="eventItems.length > 0">
    <h4>Are you interested in any game? </h4>
    <v-row>
      <v-checkbox
        v-for="item in eventItems"
        :key="item.item_id"
        v-model="selectedItems"
        :label="item.item_name"
        :value="item.item_id"
      >
      </v-checkbox>
    </v-row>
  </v-form>
</v-container>
</template>
<script>
export default {
  props: ["eventItems", "events"],
  data() {
    return {
      selectedItems: [],
      eventCount: 0,
    };
  },
  watch: {
    selectedItems: function (newSelected) {
      if (newSelected.length > 0) {
        // Add selected items to a global array.
        this.$store.commit("SET_SELECTED_ITEMS", this.selectedItems)
      } else {
        this.$store.commit("SET_SELECTED_ITEMS", this.selectedItems)
      }
    },
  },
};
</script>
